import { render, staticRenderFns } from "./SimpleBarGraph.vue?vue&type=template&id=0bf022b6&scoped=true&"
import script from "./SimpleBarGraph.vue?vue&type=script&lang=js&"
export * from "./SimpleBarGraph.vue?vue&type=script&lang=js&"
import style0 from "./SimpleBarGraph.vue?vue&type=style&index=0&id=0bf022b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf022b6",
  null
  
)

export default component.exports